export var BASE_SIZE = 36;
export var BASE_FONT_SIZE = 16;
export var FONT_MULTIPLIER = 3;